const acc = document.getElementsByClassName("accordion-custom");

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    /* Toggle between adding and removing the "accordion-custom--active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("accordion-custom--active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;

    // Stop if the next element doesn't exist or contains matching class
    if (!panel || !panel.classList.contains("accordion-custom-panel")) {
      return;
    }

    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
